import {
  DefaultOptions,
  QueryClient,
  QueryClientConfig,
  QueryOptions,
} from '@tanstack/react-query';

const preferOfflineFirst: QueryOptions = {
  networkMode: 'offlineFirst',
};

const defaultOptions: DefaultOptions = {
  queries: {
    ...preferOfflineFirst,
    retry: 1,
    refetchOnWindowFocus: true,
    staleTime: 6 * 60 * 60 * 1000,
    gcTime: 6 * 60 * 60 * 1000,
  },
  mutations: { ...preferOfflineFirst, retry: 0 },
};

const initQueryClient = (options: QueryClientConfig = {}) =>
  new QueryClient({
    defaultOptions,
    ...options,
  });

export const queryClient = initQueryClient();
